<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>
<style>
  .my-flex-b {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .my-flex-a {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .my-absolute {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .bottom-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .my-table-column {
    padding-top: 0!important;
  }
  .my-table-column .cell {
    padding-top: 12px;
    overflow: visible!important;
  }
</style>
